DOMReady( function(){
  /* ========================================================================
  * bloc more contents
  * ======================================================================== */
  if( document.querySelector('.more-contents') && document.querySelectorAll('.more-contents').length > 0 )
  {

    [... document.querySelectorAll('.more-contents .more-contents-header .title')].map( elt => {
      elt.addEventListener('click', function(e){
        e.preventDefault();

        let morecontents = elt.closest('.more-contents');

        if(elt.classList.contains('disabled') && elt.classList.contains('pourallerplusloin'))
        {
          elt.classList.remove('disabled');
          morecontents.querySelector('.more-contents-inner .pourallerplusloin').classList.remove('disabled');
          [... morecontents.querySelectorAll('.more-contents .memesujet')].map( eltDisabled => {
            eltDisabled.classList.add('disabled');
          });
        }
        else{
          elt.classList.remove('disabled');

          morecontents.querySelector('.more-contents-inner .memesujet').classList.remove('disabled');
          [... morecontents.querySelectorAll('.more-contents .pourallerplusloin')].map( eltDisabled => {
            eltDisabled.classList.add('disabled');
          });
        }
      });

    });
  }
});
